// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"58d1dace","158":"548de344","483":"436947fb","826":"5105547b","926":"e0f6c30f"}[chunkId] + ".css";
};